import { render, staticRenderFns } from "./ws-theme-service.vue?vue&type=template&id=c8dc194c&"
import script from "./ws-theme-service.vue?vue&type=script&lang=js&"
export * from "./ws-theme-service.vue?vue&type=script&lang=js&"
import style0 from "./ws-theme-service.vue?vue&type=style&index=0&id=c8dc194c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports